import React, {useState} from 'react';
import UnderLineImage from '../assets/img/subject_underline_shine_effect.png'
import {feedbackRef, firestore} from "../config/firebaseConfig";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {getCurrentUser} from "./root/helpers";
import FiveStepSlider, {S3_GRAD, S3_VALS, S5_GRAD, S5_VALS} from "../components/feedback/SteppedSlider";

const feedbackStepsData = [
    {   question: "How would you the overall rate event?",
        anser: ['Poor', 'Fair', 'Good', 'Very Good', 'Excellent']
    },
    {
        question: "Was the event well organized?",
        anser: ['Not organized at all', 'Not so organized', 'Somewhat organized', 'Very organized', 'Extremely organized']
    },
    {
        question: "Was the navigation through the online platform easy and intuitive?",
        anser: ['Not at all', 'Somewhat easy & intuitive', 'Very easy & intuitive']
    },
    {
        question: "How did you find the event duration?",
        anser: ['Too short', 'About right', 'Too long']
    },
];

const feedbackFormData = [
    {question: " What did you like about this event?"},
    {question: " Which part of the event do you think can be improved on? "},
    {question: "Is there anything else about the event which you would like to share or comment on?"},
];

const Mark = {
    ONE: 15,
    TWO: 30,
    THREE: 45,
    FOUR: 60,
    FIVE: 75
}



const FeedbackPage = props => {
    const [feedbackIsSubmited, setFeedbackIsSubmited] = React.useState(null);

    const [feedback, setFeedback] = useState({
        question1: {
            question: feedbackStepsData[0].question,
            answer: "0",
        },
        question2: {
            question: feedbackStepsData[1].question,
            answer: "0",
        },
        question3: {
            question: feedbackStepsData[2].question,
            answer: "0",
        },
        question4: {
            question: feedbackStepsData[3].question,
            answer: "0",
        },
        question5: {
            question: feedbackFormData[0].question,
            answer: "",
        },
        question6: {
            question: feedbackFormData[1].question,
            answer: "",
        },
        question7: {
            question: feedbackFormData[2].question,
            answer: "",
        },
    });


    React.useEffect(() => {
        const thisUserId = getCurrentUser().CustID;
        feedbackRef
            .where("userId", "==", thisUserId)
            .get()
            .then(querySnapshot => {
                setFeedbackIsSubmited(querySnapshot.docs.length > 0)
            });

    }, []);


    const sendFeedback = async (e) => {
        const itemFeedback = {
            ...feedback,
            userId: getCurrentUser().CustID,
            timestamp: Date.now(),
        };
        setFeedbackIsSubmited(true);
        await feedbackRef.add(itemFeedback);
    };

    return (
        <div id="bg" className="feedback-wall">
            {feedbackIsSubmited !== null ? <div>
                {!feedbackIsSubmited ?
                    <div>
                        <div className="feedbacksaid">
                            <div className="feedbacksurvey">
                                <div style={{marginBottom: '10px'}}>
                                    <h2>Feedback</h2>
                                    <h2> Survey</h2>
                                </div>
                                <img
                                    alt={""}
                                    src={UnderLineImage}
                                    style={{width: "100%", height: "7px"}}
                                />
                            </div>

                            <div className="feedback-container">
                                <div className='thxjoining'>
                                    <p style={{marginBottom: '15px'}}>
                                        Thank you for joining us in Singapore Business Awards 2020. It was a pleasure to
                                        have you.
                                    </p>
                                    <p>We would appreciate it if you could take some time to share your feedback with us
                                        so that</p>
                                    <p>we can make it better next year.</p>
                                </div>
                                <div className='feedback-steps-wall'>
                                    <div className='scroll custom-scrollbar'>
                                        <div className='feedback-steps'>
                                            {feedbackStepsData.map((item, index) =>
                                                <FeedbackStep key={index}
                                                              index={index}
                                                              question={item.question}
                                                              answers={item.anser}
                                                              value={feedback['question' + (1 + index)].answer}
                                                              onChange={v => setFeedback({
                                                                  ...feedback,
                                                                  ['question' + (1 + index)] : {
                                                                      ...feedback['question' + (1 + index)],
                                                                      answer : v
                                                                  }
                                                              })}/>
                                            )}
                                        </div>
                                        <div className='formquestion'>
                                            {feedbackFormData.map((item, index) =>
                                                <FeedbackForm key={index}
                                                              index={index + 5}
                                                              question={item.question}
                                                              value={feedback['question' + (index + 5)].answer}
                                                              onChange={(e) => setFeedback({
                                                                  ...feedback,
                                                                  ['question' + (5 + index)] : {
                                                                      ...feedback['question' + (5 + index)],
                                                                      answer : e.target.value
                                                                  }
                                                              })}
                                                />
                                            )}
                                        </div>
                                        <button onClick={() => sendFeedback()} className='formbutton'>Submit</button>
                                    </div>
                                </div>
                            </div>
                            <div className="feedback-right-space"/>

                        </div>
                    </div>

                    :


                    <div className='thanksfeedback'>
                        <h1>Thank you for your feedback</h1>
                        <img
                            alt={""}
                            src={UnderLineImage}
                            style={{width: "90%", height: "9px"}}
                        />
                    </div>
                }
                <div>
                </div>
            </div> : <div style={{fontSize: '3em', color: "white"}}>Loading...</div>}
        </div>
    )
};

export default FeedbackPage;


const FeedbackStep = props => {
    const {index, question, answers, value, onChange} = props;
    return (
        <div className='feedback-steps'>
            <label>{index + 1 + '. ' + question}</label>
            <FiveStepSlider type="range" min="0" max="100"
                            value={value}
                            onChange={onChange}
                            vals={answers.length === 5 ? S5_VALS : S3_VALS}
                            grads={answers.length === 5 ? S5_GRAD : S3_GRAD}
            />
            <div className='feedback-anser-level'>{answers.map((el, index) => <p key={index}>{el}</p>)}</div>
        </div>
    )
};


const FeedbackForm = props => {

    const {index, question, value, onChange} = props;
    return (
        <>
            <label>{index + '. ' + question}</label>
            <div className={'text-area-bg'}>
                <textarea value={value} onChange={onChange}/>
            </div>
        </>
    )
};